import type { TSYSTEM_PERMISSIONS } from '../../constants/permissions';
import { baseApi } from '../../api/baseApi';

export interface LoginRequest {
  email: string;
  password?: string;
}

export interface Store {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  mapsUrl?: string;
}

export interface LoginResponse {
  token: string;
  partner: {
    id: string;
    name: string;
    subdomain: string;
    industry?: {
      id: string;
      name: string;
      type: string;
    };
    exchangeRateCode: 'USD' | 'EUR';
  } | null;
  allowedStores: Store[];

  allowedPermissions: TSYSTEM_PERMISSIONS[];
  isSuperadmin?: boolean;
  type: number;
}

export interface RolePermissionsResponse {
  permissions: TSYSTEM_PERMISSIONS[];
  role: string;
}

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    getRolePermissions: builder.query<RolePermissionsResponse, string>({
      query: (partnerLocationId) => ({
        url: `/role/permissions/${partnerLocationId}`,
        method: 'GET',
      }),
      transformResponse: (response: any): RolePermissionsResponse => {
        if (response?.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
          return response.data;
        }
        return response;
      },
    }),
  }),
  overrideExisting: false,
});

export const { useLoginMutation, useGetRolePermissionsQuery, useLazyGetRolePermissionsQuery } =
  authApi;
